import React from 'react';
import firebase from '../../firebase';

import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input';

import classes from './Resource.module.css';

const resource = ( props ) => {
    let imageTag = null;
    if( props.resource.image ) {
        imageTag = ( <img id={props.resource.image + 'Image'} className={classes.Image} src={''} alt={'Resource'} /> );
        const storage = firebase.storage();
        const image = storage.ref( props.resource.image );
        image.getDownloadURL()
            .then( resp => {
                document.getElementById( props.resource.image + 'Image' ).setAttribute( 'src', resp );
            } )
    }
    return (
        <div key={props.resource.id} className={classes.Resource}>
            {
                props.resource.formElements.map( formElement => {
                    if( typeof formElement.config === 'object' ) {
                        return <Input
                            changed={( event ) => props.inputChangedHandler( event, formElement.id )}
                            key={formElement.id}
                            elementId={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            label={formElement.config.label}
                        //invalid={!formElement.config.valid}
                        //shouldValidate={formElement.config.validation}
                        //touched={formElement.config.touched}
                        /*clicked={(event) => this.removeResource(event, formElement.id)}*/
                        />
                    } else { return null; }
                }
                )}
            {imageTag}
            <Button clicked={( event ) => props.updateResourceHandler( event, props.resource.dbKey, props.resource.id )}>UPDATE RESOURCE</Button>
            <Button clicked={( event ) => props.removeResourceHandler( event, props.resource.dbKey )}>REMOVE RESOURCE</Button>
        </div>
    );
}

export default resource;